import { Group, Title } from "@mantine/core"
import { Badge, BadgeVariant } from "@tfg/ui"

interface RequestTabHeaderProps {
  count: number
  label: string
  variant?:
    | "info"
    | "warning"
    | "success"
    | "error"
    | "primary"
    | "secondary"
    | "admin"
}

export const RequestTabHeader = ({ count, label }: RequestTabHeaderProps) => {
  return (
    <Group>
      <Badge
        variant={count > 0 ? BadgeVariant.PRIMARY : BadgeVariant.SECONDARY}
        text={count.toString()}
      />
      <Title order={6} fw={400}>
        {label}
      </Title>
    </Group>
  )
}
